import { useCallback, useEffect, useState } from 'react'
import { adminService } from '@/services/adminService'
import type { AdminUserListItem } from '@/types/admin'

interface UseAdminUserResult {
  user: AdminUserListItem | null
  loading: boolean
  error: string | null
  reload: () => Promise<void>
}

/**
 * Loads a single user for the admin detail page.
 */
export function useAdminUser(uid: string | undefined): UseAdminUserResult {
  const [user, setUser] = useState<AdminUserListItem | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const reload = useCallback(async () => {
    if (!uid) {
      setError('Användar-ID saknas')
      setLoading(false)
      return
    }
    setLoading(true)
    setError(null)
    try {
      setUser(await adminService.getUser(uid))
    } catch (err) {
      console.error('Failed to load admin user:', err)
      setError('Kunde inte hämta användaren. Försök igen senare.')
    } finally {
      setLoading(false)
    }
  }, [uid])

  useEffect(() => {
    reload()
  }, [reload])

  return { user, loading, error, reload }
}
